export default "__VITE_ASSET__CME_otc2__"